import { initializeApp } from 'firebase/app';
import {
  getAuth,
  onAuthStateChanged,
  signOut,
  signInWithEmailAndPassword,
  User,
  createUserWithEmailAndPassword,
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFirebaseConfig } from './firebaseConfig';

// 1. Initialize Firebase app
const app = initializeApp(getFirebaseConfig());

// 2. Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// 3. Auth helpers
export async function signInUser(email: string, password: string) {
  if (!email || !password) return;
  return signInWithEmailAndPassword(auth, email, password);
}

export function userStateListener(callback: (user: User | null) => void) {
  return onAuthStateChanged(auth, callback);
}

export async function SignOutUser(): Promise<void> {
  await signOut(auth);
}
export const signUpUser = (email: string, password: string) =>
  createUserWithEmailAndPassword(auth, email, password);

export const signOutUser = () => signOut(auth);
